// extracted by mini-css-extract-plugin
module.exports = {"root":"InstallPrompt_root__AT0Mi","text":"InstallPrompt_text__c1qbc","cta":"InstallPrompt_cta__hQ0lA","close":"InstallPrompt_close__j0Bsy"};